import Message from '../classes/message';

const message = (state = [], action) => {
  switch (action.type) {
    case 'SET_MESSAGE':
      return [...state, new Message(action.message)];
    case 'CLEAR_MESSAGE': {
      const messageToDelete = state.findIndex(e => e.messageId === action.messageId);
      state.splice(messageToDelete, 1);
      return [...state];
    }
    default:
      return state;
  }
};

export default message;
